// Shared generator / project display utilities

export function techTypeLabel(techTypeId: string | null): string {
  if (!techTypeId) return "Unknown";
  if (techTypeId.startsWith("solar")) return "Solar";
  if (techTypeId.startsWith("wind")) return "Wind";
  return techTypeId.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

export function getTechColor(technology: string | null): string {
  if (technology?.includes("Solar")) return "#eab308";
  if (technology?.includes("Wind")) return "#14b8a6";
  if (technology?.includes("Nuclear")) return "#a855f7";
  if (technology?.includes("Natural Gas")) return "#f97316";
  if (technology?.includes("Hydro")) return "#06b6d4";
  if (technology?.includes("Battery")) return "#84cc16";
  if (technology?.includes("Coal")) return "#78716c";
  return "#3b82f6";
}

export function getStatusBadgeColor(status: string | null): string {
  if (!status) return "bg-gray-500/20 text-gray-400";
  if (status === "OP") return "bg-green-500/20 text-green-400";
  if (status === "SB") return "bg-yellow-500/20 text-yellow-400";
  if (status === "P" || status === "L") return "bg-blue-500/20 text-blue-400";
  if (["T", "U", "V"].includes(status)) return "bg-orange-500/20 text-orange-400";
  if (status === "TS") return "bg-red-500/20 text-red-400";
  return "bg-gray-500/20 text-gray-400";
}

export function formatCapacity(mw: number): string {
  if (mw >= 1000) return `${(mw / 1000).toFixed(1)} GW`;
  return `${mw.toFixed(0)} MW`;
}
